import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {NotifierService} from '../../services/notifier.service';
import {GamesService} from '../../../../../services/games.service';
import {animate,  style, transition, trigger} from '@angular/animations';
// import {DomService} from '../../services/dom.service';
import {CentruiHelpFormComponent} from '../centrui-help-form/centrui-help-form.component';
import { CentruiAvatarComponent } from '../centrui-avatar/centrui-avatar.component';
import {CommonModule} from '@angular/common';
import {RouterLink} from "@angular/router";
import {DarkModeDirective} from "../../directives/dark-mode.directive";
import { PxTooltipDirective } from '../../directives/px-tooltip/px-tooltip.directive';
import { SvgIconComponent } from "angular-svg-icon";
import { slideEnterLeaveLeft } from '../../../../../common/animations';

export class MenuItem {
  title?: string;
  routerLink?: string;
  callback?: any;
  icon?: string;
  darkIcon?: string;
  conditionallyShown?: boolean;
  class?: string;
}
@Component({
  selector: 'app-centrui-menu',
  templateUrl: './centrui-menu.component.html',
  styleUrls: ['./centrui-menu.component.scss'],
  animations: [
    slideEnterLeaveLeft,
    trigger('toggleLogout', [
      transition(':enter', [
        style({opacity: 0, transform: 'translateX(-50px)'}),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        style({opacity: 1, transform: 'translateX(0)'}),
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50px)' })),
      ]),
    ])
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CentruiHelpFormComponent, CentruiAvatarComponent, CommonModule, RouterLink, DarkModeDirective, PxTooltipDirective, SvgIconComponent]
})
export class CentruiMenuComponent implements OnInit, AfterViewInit {
  @Input() active!: string;
  @Input() hasLabel!: boolean;
  @Input() callBack!: () => void;
  @Input() label!: string;
  @Input() src!: string;
  @Input() avatarType!: string;
  @Input() fullName!: string;
  @Input() firstInitial!: string;
  @Input() appLogoSrc!: string;
  @Input() appName!: string;
  @Input() menuItems!: MenuItem[];
  @Input() extraHelpTemplate?: TemplateRef<unknown>;

  showLogout = false;
  showHelp = false;

  constructor(
    public authService: AuthService,
    private notifierService: NotifierService,
    private router: Router,
    private gamesService: GamesService,
  ) {

  }

  onPoweredByContextMenu(event: MouseEvent): void {
    if (!this.router.url.includes('/projects/view/')) {
      return;
    }
    event.preventDefault();
    this.gamesService.requestOpenGamesModal();
  }

  ngOnInit(): void { }

  logout(): void {
    this.authService.logout().subscribe(response => {
      this.notifierService.notifyResponse(response);
    });
  }

  toggleLogout(): void {
    this.showLogout = !this.showLogout;
  }

  showHelpForm(): void {
    // this.domService.appendComponentToBody(CentruiHelpFormComponent);
  }

  appHeight = () => {
    const doc = document.documentElement
    // doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }

  ngAfterViewInit(): void {
    window.addEventListener('resize', this.appHeight);
    this.appHeight();
  }
}
